import React, {
  useCallback,
  useEffect,
  useRef,
  useState
} from 'react';
import { useHistory, useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import {
  Card,
  Tabs,
  Tab,
  Grid,
  TextField,
  Fab
} from '@material-ui/core';
import { TabPanel, TabContext } from '@material-ui/lab';
import useDebounce from 'hooks/UseDebounce';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import ScrollTop from 'components/ToolbarMenu/ScrollOnTop';
import { getMetadataAPI } from 'api';
import { BackdropCircular } from 'components';
import BrowsePromoBrandsSearchResults from './BrowsePromoBrandsSearchResults';


const tabsUrlValues = [
  'browse-promotion',
  'browse-not-branded-promotion',
  'browse-by-manufacturer'
];

const BrowsePromoByBrand = () => {
  const {selectedTab} = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const scrolledContainerRef = useRef(null);
  const [tabIndex, setTabIndex] = useState(selectedTab ? tabsUrlValues.indexOf(selectedTab) : 0);
  const [searchBrand, setSearchBrand] = useState('');


  const {metadata = {}, browsePromoLoading} = useSelector((state) => state.promo);

  useEffect(() => {
    getMetadataAPI({dispatch, usedIn: 'globalLibrary'});
  }, []);

  const handleChange = useCallback((event) => {
    setSearchBrand((event.target.value).toLowerCase());
  }, []);

  const handleChangeTab = (value) => {
    history.push(`/promotions-library/${tabsUrlValues[value]}`);

    setTabIndex(value);
    setSearchBrand('');
  };


  const debouncedSearchBrand = useDebounce(searchBrand, 300);

  return (
    <>
      <Card className="m-10 p-7">
        <TabContext value={tabIndex}>
          <Tabs
            value={tabIndex}
            onChange={(e, value) => handleChangeTab(value)}
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab className="capitalize font-medium" value={0} label="Browse Promotion" />
            <Tab className="capitalize font-medium" value={1} label="Browse Not Branded Promotion" />
            <Tab className="capitalize font-medium" value={2} label="Browse by Manufacturer" />
          </Tabs>
          <TabPanel value={0}>
            <Grid item xs={12} className="flex justify-between items-center mb-12">
              <TextField
                label="Search Brand..."
                variant="outlined"
                className="w-full"
                style={{maxWidth: '300px'}}
                onChange={handleChange}
              />
            </Grid>

            <BrowsePromoBrandsSearchResults
              results={metadata['Brands'] || []}
              debouncedSearchBrand={debouncedSearchBrand}
              selectedTab={selectedTab}
            />
          </TabPanel>
          <TabPanel value={1}>
            <Grid item xs={12} className="flex justify-between items-center mb-12">
              <TextField
                label="Search Listing type..."
                variant="outlined"
                className="w-full"
                style={{maxWidth: '300px'}}
                onChange={handleChange}
              />
            </Grid>

            <BrowsePromoBrandsSearchResults
              results={metadata['Listing type'] || []}
              debouncedSearchBrand={debouncedSearchBrand}
              selectedTab={selectedTab}
            />
          </TabPanel>
          <TabPanel value={2}>
            <Grid item xs={12} className="flex justify-between items-center mb-12">
              <TextField
                label="Search Manufacturer..."
                variant="outlined"
                className="w-full"
                style={{maxWidth: '300px'}}
                onChange={handleChange}
              />
            </Grid>
            <BrowsePromoBrandsSearchResults
              results={metadata['Manufactures'] || []}
              debouncedSearchBrand={debouncedSearchBrand}
              selectedTab={selectedTab}
            />
          </TabPanel>
        </TabContext>


      </Card>
      <ScrollTop refEl={scrolledContainerRef.current}>
        <Fab
          color="secondary"
          className="custom-scroll-button"
          size="small"
          aria-label="scroll back to top"
        >
          <KeyboardArrowUpIcon />
        </Fab>
      </ScrollTop>
      <BackdropCircular
        loading={browsePromoLoading}
      />
    </>
  );
};

export default BrowsePromoByBrand;
